import { MaintenancePage as Maintenance } from '@repo/ui/features/platform';

export default function MaintenancePage() {
  return <Maintenance />;
}
